import { render, staticRenderFns } from "./BlogPosts.vue?vue&type=template&id=30b54f50&"
import script from "./BlogPosts.vue?vue&type=script&lang=js&"
export * from "./BlogPosts.vue?vue&type=script&lang=js&"
import style0 from "./BlogPosts.vue?vue&type=style&index=0&id=30b54f50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports